import { concat } from 'ramda';
import { generateListTags } from 'utils/helpers/fetch';
import shippingApi from '../shippingApi';

const getUrl = concat('monthly-nominations/');

const nominationsEndpoints = shippingApi.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    createNomination: mutation({
      invalidatesTags: [{ id: 'LIST', type: 'Nomination' }],
      query: ({ body }) => ({
        body,
        method: 'POST',
        url: getUrl('create-nomination'),
      }),
    }),
    editNomination: mutation({
      query: ({ nominationId, volNominated }) => ({
        body: { nominationId, volume: volNominated },
        method: 'POST',
        url: getUrl('edit-nomination'),
      }),
    }),
    electNomination: mutation({
      invalidatesTags: (result, error, { nominationId, volAccepted }) => [
        { id: nominationId, type: 'Nomination' },
        { id: volAccepted === 0 ? 'REJECTED' : 'ACCEPTED', type: 'Nomination' },
      ],
      query: ({ nominationId, volAccepted }) => ({
        body: { nominationId, volume: volAccepted },
        method: 'POST',
        url: getUrl('elect-nomination'),
      }),
    }),
    getCurrentNominations: query({
      providesTags: (result, _, { nominationState }) => [
        ...generateListTags('Nomination', 'nominationId', result),
        { id: nominationState, type: 'Nomination' },
      ],
      query: ({ nominationState }) => ({
        params: { nominationState },
        url: getUrl('get-current-nominations'),
      }),
    }),
    getHistoricalNominations: query({
      providesTags: (result, _, { fromDate, toDate }) => [
        { id: `${fromDate}-${toDate}`, type: 'NominationHistorical' },
      ],
      query: ({ fromDate, toDate }) => ({
        params: { fromDate, toDate },
        url: getUrl('get-historical-nominations'),
      }),
      transformResponse: response => response.historical,
    }),

    getNominationLegPeriod: query({
      providesTags: generateListTags('NominationMonth', 'nominationMonthId'),
      query: ({ nominationLegId }) => ({
        params: { nominationLegId },
        url: getUrl('get-nomination-leg-periods'),
      }),
    }),

    getNominationLegProducts: query({
      providesTags: generateListTags('NominationProductGrade', 'nominationProductGradeId'),
      query: ({ nominationLegId, periodId, shipper }) => ({
        params: { nominationLegId, periodId, shipper },
        url: getUrl('get-nomination-leg-products'),
      }),
    }),

    getNominationsLegs: query({
      providesTags: generateListTags('NominationLeg', 'nominationLegId'),
      query: ({ shipper }) => ({
        params: { shipper },
        url: getUrl('get-nomination-legs'),
      }),
    }),
  }),
});

export const {
  useCreateNominationMutation,
  useEditNominationMutation,
  useElectNominationMutation,
  useGetCurrentNominationsQuery,
  useGetHistoricalNominationsQuery,
  useGetNominationLegPeriodQuery,
  useGetNominationLegProductsQuery,
  useGetNominationsLegsQuery,
} = nominationsEndpoints;
